import api, { ApiResponse } from './api';

export interface DashboardStats {
  live: number;
  scheduled: number;
  completed: number;
  errors: number;
}

export interface DashboardScheduleItem {
  id: number;
  event_title: string;
  event_start_time: string;
  event_end_time: string | null;
  status: number;
  xaccel_channel_name: string | null;
  competition_id: number | null;
  competition_name: string | null;
  sport_name: string | null;
  xaccel_real_status: string | null;
  xaccel_clients: number | null;
  xaccel_uptime: number | null;
  home_team: string | null;
  away_team: string | null;
  channel_mode: string | null;
  channel_prefix: string | null;
  servers?: Array<{ id: number; name: string; server_type: string; status: string }>;
  /** Status 0 after a partial multi-resolution start: { running, total }; absent otherwise */
  partial_start?: { running: number; total: number };
}

export interface DashboardNextEvent {
  event_title: string;
  event_start_time: string;
  competition_name: string | null;
}

export interface DashboardOverview {
  sportsCount: number;
  activeCompetitions: number;
  nextEvent: DashboardNextEvent | null;
  daznSubscriptionStatus: string | null;
  daznSubscriptionPlan: string | null;
  runningLinearChannels: number;
}

export interface DashboardLogEntry {
  id: number;
  log_type: string;
  level: string;
  message: string;
  created_at: string;
}

export interface DashboardLinearSubChannel {
  channel_name: string;
  resolution: string;
  db_status: string;
  real_status: string;
  clients: number;
  uptime: number;
  mismatch: boolean;
  server_id: number;
  server_name: string;
  server_type: string;
}

export interface DashboardLinearChannel {
  id: number;
  name: string;
  playback_identity?: 'web' | 'androidtv' | null;
  db_status: string;
  real_status: string;
  mismatch: boolean;
  sub_channels: DashboardLinearSubChannel[];
}

export interface DashboardData {
  stats: DashboardStats;
  todaySchedule: DashboardScheduleItem[];
  overview: DashboardOverview;
  linearChannels: DashboardLinearChannel[];
  recentLogs: DashboardLogEntry[];
}

export const dashboardService = {
  async getStats(): Promise<DashboardData> {
    const response = await api.get<ApiResponse<DashboardData>>('/dashboard/stats');
    return response.data.data;
  },
};
